/**
 * 热键速查卡：让辩手在不看鼠标的情况下也能发现全部操作。
 */
import { KeyHint } from '../ui/primitives.tsx';

const HOTKEYS: { keys: string[]; label: string; detail: string }[] = [
  { keys: ['Space'], label: '切换发言权', detail: '双表 Chess Clock 交替（仅允许切换的环节）' },
  { keys: ['Tab'], label: '隐藏反杀锦囊', detail: '展开 / 折叠当前底牌底部锦囊' },
  { keys: ['1', '2', '3'], label: '勾选必打论据', detail: '标记第 1/2/3 条论据已完成' },
  { keys: ['⌘', 'K'], label: '论据检索', detail: '端侧 BM25 速查，不跳转页面' },
  { keys: ['Esc'], label: '关闭检索', detail: '检索浮层打开时生效' },
];

export function HotkeyLegend() {
  return (
    <section
      data-testid="hud-hotkeys"
      aria-label="热键速查"
      className="rounded-xl border border-white/10 bg-bg-surface/80 p-3 backdrop-blur"
    >
      <h2 className="mb-2 text-sm font-semibold tracking-wide text-slate-100">全键盘盲操</h2>
      <ul className="space-y-1.5">
        {HOTKEYS.map((hotkey) => (
          <li key={hotkey.label} className="flex items-start gap-2">
            <span className="flex shrink-0 items-center gap-1">
              {hotkey.keys.map((key) => (
                <KeyHint key={key}>{key}</KeyHint>
              ))}
            </span>
            <span className="min-w-0">
              <span className="block text-[11px] text-slate-300">{hotkey.label}</span>
              <span className="block text-[10px] text-slate-600">{hotkey.detail}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
